package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px

val PersonalizedSectionButtonStyle = CssStyle {
    base {
        Modifier
            .height(35.px)
            .styleModifier {
                property("width", "fit-content")
            }
            .cursor(Cursor.Pointer)
    }

    Breakpoint.MD {
        Modifier.height(45.px)
    }

    Breakpoint.LG {
        Modifier
            .height(50.px)
            .width(315.px)
    }
}

val PersonalizedSectionIconStyle = CssStyle {
    base {
        Modifier.size(22.px)
    }

    Breakpoint.MD {
        Modifier.size(26.px)
    }

    Breakpoint.LG {
        Modifier.size(30.px)
    }
}

val PersonalizedSectionTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.SemiBold)
    }

    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }

    Breakpoint.LG {
        Modifier.fontSize(20.px)
    }
}

val PersonalizedSectionChevronStyle = CssStyle {
    base {
        Modifier.size(18.px)
    }

    Breakpoint.MD {
        Modifier.size(20.px)
    }

    Breakpoint.LG {
        Modifier.size(25.px)
    }
}

val DropdownItemTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.Medium)
    }

    Breakpoint.MD {
        Modifier.fontSize(18.px)
    }
}
